<template>
	<div class="report-wrapper">
		<header class="toolbar">
			<div class="left-group">
				<el-select v-model="query.user" size="small" style="width: 140px">
					<el-option label="lining1989" value="lining1989" />
				</el-select>
				<el-date-picker v-model="query.range" type="daterange" size="small" value-format="yyyy-MM-dd"
					style="width: 240px" />
				<span class="tip"><i class="el-icon-info" /> 2026-01-19 09:10:08 更新数据</span>
			</div>

			<div class="right-group">
				<el-button size="small" icon="el-icon-download">导出 <i class="el-icon-info" /></el-button>
				<el-pagination :current-page.sync="currentPage" :page-sizes="[10, 20, 50]" :total="tableData.length"
					layout="total, sizes, prev, pager, next, jumper" @size-change="fetchData"
					@current-change="fetchData" />
			</div>
		</header>

		<el-table :data="tableData" border class="main-table" :header-cell-style="{ background: '#f8f8f9' }">
			<el-table-column prop="name" label="成员" />
			<el-table-column prop="group" label="分组" />
			<el-table-column v-for="col in iconColumns" :key="col.prop" :prop="col.prop" sortable>
				<template #header><i class="el-icon-question" /> {{ col.label }}</template>
			</el-table-column>
			<el-table-column prop="onlineRatio" label="线上时长占比" sortable />
			<el-table-column prop="busyRatio" label="忙碌时长占比" sortable />
			<el-table-column prop="offlineRatio" label="离线时长占比" sortable />
		</el-table>
	</div>
</template>

<script>
export default {
	data() {
		return {
			query: { user: 'lining1989', range: ['2026-01-19', '2026-01-19'] },
			currentPage: 1,
			iconColumns: [
				{ prop: 'loginTime', label: '登入时长' },
				{ prop: 'onlineTime', label: '线上时长' },
				{ prop: 'busyTime', label: '忙碌时长' },
				{ prop: 'offlineTime', label: '离线时长' }
			],
			tableData: [{
				name: 'lining1989', group: '44,123', loginTime: '9时 4分 39秒', onlineTime: '9时 4分 39秒',
				onlineRatio: '100%', busyTime: '0秒', busyRatio: '0%', offlineTime: '0秒', offlineRatio: '0%'
			}]
		}
	}
}
</script>

<style lang="scss" scoped>
.report-wrapper {
	padding: 15px;
	background: #fff;

	.toolbar {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 15px;
		border-bottom: 1px solid #f0f0f0;

		.left-group,
		.right-group {
			display: flex;
			align-items: center;
			gap: 10px; // 统一间距
		}

		.tip {
			font-size: 12px;
			color: #999;

			i {
				margin-right: 4px;
			}
		}

		.mini-pager {
			display: flex;
			align-items: center;
			font-size: 13px;
			color: #666;
			margin-left: 15px;

			i {
				margin: 0 8px;
				color: #ccc;
				cursor: pointer;

				&:hover {
					color: #409EFF;
				}
			}

			.current {
				font-weight: 500;
			}
		}
	}

	.main-table {
		margin-top: 15px;

		::v-deep th {
			color: #606266;
			font-weight: 500;

			.el-icon-question {
				color: #909399;
				margin-right: 3px;
			}
		}
	}
}
</style>